import { FormControl, Stack, TextField } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TPCheckbox from "../../../TemplateProperties/TPCheckbox";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useSelector } from "react-redux";
import { getParentArray } from "../FieldPropertyForm";
import { getSelectedNodes } from "../../../RightContextMenu/ContextActions/CopyAndPaste";

const EDIFieldProperty = ({handleChange,checked,setChecked}) => {
  const { t } = useTranslation();
  const [elementId,setElementId] = useState('');
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const templateHeader = rightTree.tree.templateHeader;
  const [showCheckBox,setShowCheckBox] = useState(false);


  useEffect(()=>{
    setElementId(selectedNode?.ELEMENT_ID || '');
    isShowRepeatableField();
  },[selectedNode?.key])


  const isShowRepeatableField = ()=>{
    let keysArray = selectedNode?.key?.split('-');
    keysArray?.splice(keysArray?.length -1);
    keysArray = keysArray.join('-')
    const isShow  = !getSelectedNodes([keysArray],translatedData)?.[0]?.ICON_DISPLAY?.includes("FIELD_GROUP") 
    setShowCheckBox(isShow);
  }

  return (
    <>
        
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_ELEMENT_ID")}
            type="text"
            className={"width-100"}
            value={elementId}
            onChange={(e) => {
              const { value } = e.target;
              setElementId(value);
              handleChange('ELEMENT_ID',value);
            }}
          />
        </FormControl>
        <FormControl className="width-100" size="small">
          {!['4010','4010A1'].includes(templateHeader?.FILETYPE_VERSION) && 
          showCheckBox && 
          <TPCheckbox
            label={t("BTN_ELE_REPEATABLE")}
            checked={checked}
            handleCheck={(checked) => {
                setChecked(checked)
                handleChange('REPEATING',checked);
            }}
          />}
        </FormControl>
    </>
  );
};

export default EDIFieldProperty;
